import { FormControl as MUIFormControl } from '@mui/material'
import styled from 'styled-components'

export const FormControl = styled(MUIFormControl)`
  label {
    color: #9a9ab1;
    font-family: 'Roboto', sans-serif;
  }
`
